import { IRouteChild } from '@simac/ui';
import { FieldRetourMoveAssetRoute } from './move-asset/move-asset.routes';
import { FieldRetourMovePalletRoute } from './move-pallet/move-pallet.routes';

export const FieldRetourRoute: IRouteChild[] = [
  {
    title: 'MENU.FIELDSUPPORT.MOVE-ASSET',
    icon: 'far fa-gem',
    route: FieldRetourMoveAssetRoute,
  },
  {
    title: 'MENU.FIELDSUPPORT.MOVE-PALLET',
    icon: 'far fa-pallet-box',
    route: FieldRetourMovePalletRoute,
  },
];
